import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";

function RatingComponent({ value, onChange }) {
  return (
    <FormControl>
      <FormLabel id="demo-form-control-label-placement">
        <div className="title-rating">
          {" "}
          Overall level of engagement in the program
        </div>
      </FormLabel>
      <RadioGroup
        className="radio-group-container"
        row
        aria-labelledby="demo-form-control-label-placement"
        name="position"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <FormControlLabel
          value="1"
          control={<Radio />}
          label="Resistance"
          labelPlacement="top"
          sx={{ ".MuiFormControlLabel-label": { fontSize: 12 } }}
        />
        <FormControlLabel
          value="2"
          control={<Radio />}
          label=""
          labelPlacement="top"
        />
        <FormControlLabel
          value="3"
          control={<Radio />}
          label=""
          labelPlacement="top"
        />
        <FormControlLabel
          value="4"
          control={<Radio />}
          label=""
          labelPlacement="top"
        />
        <FormControlLabel
          value="5"
          control={<Radio />}
          label="Highly engaged"
          labelPlacement="top"
          sx={{ ".MuiFormControlLabel-label": { fontSize: 12 } }}
        />
      </RadioGroup>
    </FormControl>
  );
}

export default RatingComponent;
